'use client'

import React from 'react'
import { themeBootstrap, themeStyleSheet } from '@/lib/siteTheme'
import CriticalRecoverScreen from '@/components/CriticalRecoverScreen'

// Комментарий на русском: глобальный обработчик ошибок (когда ломается даже RootLayout).
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="ru" data-site-theme="light" suppressHydrationWarning>
      <head><style dangerouslySetInnerHTML={{ __html: themeStyleSheet() }} /><script dangerouslySetInnerHTML={{ __html: themeBootstrap() }} /></head>
      <body>
        <CriticalRecoverScreen reset={reset} />
      </body>
    </html>
  )
}


